/**
 * @module
 */

const selector = '[data-js-card-expand]';
const cardGridExpand = function(el, app) {

    const $button = $(el);
    const $section = $button.closest('.Ge-Section');
    const $content = $section.find('[data-js-card-toggle-content]');
    let   status = false;
    
    const init = function() {
        // init the events
        registerEvents();
    };

    const registerEvents = function() {

        $button.click(function(ev) {
            ev.preventDefault();
            $content.trigger('toggleAll');
            $button.toggleClass('Ge-CardGrid-Buttons-Btn--open');
            status = !status;
        });
    };

    return {
        init: init()
    };
};

cardGridExpand.selector = selector;

export default cardGridExpand;
